import { useState } from "react";
import { IoExtensionPuzzleOutline } from "react-icons/io5";
import GovernmentForm from "./GovernmentForm";
import DescriptionList from "./../../../../../components/common/DescriptionList";
import Modal from "./../../../../../components/common/Modal";

const GovernmentInformation = ({ data, isLoading, onRefresh }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const ss_number = data.ss_number ?? "-";
  const hdmf_number = data.hdmf_number ?? "-";
  const philhealth_number = data.philhealth_number ?? "-";
  const s2_license_number = data.s2_license_number ?? "-";

  const handleSuccess = () => {
    setShowForm(false);
    onRefresh();
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoExtensionPuzzleOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Compliances Information</p>
              <span className="text-xs text-gray-400">
                Government Compliances Information
              </span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 mt-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="SS No."
            className="col-span-2 lg:col-span-1"
            content={ss_number}
            isLoading={isLoading}
          />
          <DescriptionList
            label="HDMF No."
            className="col-span-2 lg:col-span-1"
            content={hdmf_number}
            isLoading={isLoading}
          />
        </div>
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Philhealth No."
            className="col-span-2 lg:col-span-1"
            content={philhealth_number}
            isLoading={isLoading}
          />
          <DescriptionList
            label="S2 License No."
            className="col-span-2 lg:col-span-1"
            content={s2_license_number}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Gov't Compliances Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <GovernmentForm
          data={data}
          isLoading={isFormLoading}
          setLoading={(value) => setIsFormLoading(value)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default GovernmentInformation;
